export default "__VITE_ASSET__fzx7ETEk__"